// START BRIAN BUCHANAN
var productHandle = '';
var productData='';
function loadProductInfo(){
  const url = window.location.pathname;
  const parts = url.split('/');
  const handleIndex = parts.indexOf('products') + 1;

  if (handleIndex > 0 && handleIndex < parts.length) {
    productHandle=parts[handleIndex];
  } else {
    return null; // Not on a product page
  }
jQuery.getJSON('/products/'+productHandle+'.js', function(product) {
  productData = product;
} );
     var shopify_object = [
      {
        name: "shop_id",
        value: localStorage["agchimp_shop_id"],
      },
      {
        name: "product_id",
        value: product_id,
      }
    ];

    exec("shopify_frontend_json_product_object_s", shopify_object,explodeData);

}

function explodeData(data) {
  console.log(data);
customShopifyData = data;
  if(customShopifyData.productDetails.hasOwnProperty('showKeyFeatures')){
    if(customShopifyData.productDetails.showKeyFeatures===true){
      $('.product-details--left').show();
    }
  }
  if(customShopifyData.productDetails.hasOwnProperty('templateSuffix')){
    
  } else {
    if(customShopifyData.productDetails.showDirectionsForUse===true){
   if(customShopifyData.productDetails.hasOwnProperty('directions')){
    
      
      $('#panel-1').html(`<div class="rte"><p>`+customShopifyData.productDetails.directions+`</p></div>`);
    } else {
     $('#panel-1').html(`<div class="rte"><p>Please consult product label for specific directions for use.</p></div>`);
    }
  }
  }
//Hide Sale Tags
  //$('.product-label--sale').hide();

    //Builds fertilizer product type components
    if (customShopifyData.productDetails.productPage === "fertilizer") {
      console.log('hasFertilizer');
      $(".fertilizerIcon").html(
        '<img src="' +
          customShopifyData.fertilizer.keyNutrientImageLink +
          '" style="height:70px;position:relative" />'
      );
      $("#fertComponentNarrative").html(
        customShopifyData.fertilizer.keyNutrientDescription
      );
      $(".fertilizerTag").html(
      '<img src="' + customShopifyData.fertilizer.imageLink + '" style="height:450px;"/>'
    );
    if(customShopifyData.fertilizer.hasOwnProperty('instructions')){
    var instructionRow = '';
      var key = 0;
    $.each(customShopifyData.fertilizer.instructions, function () {
      key = key + 1;
        instructionRow += `<div class="product-spec__fertilizer_instructions_icon text-center mb-3">
                                <img src="`+this.instructionIcon+`" style="height:60px"/>
                                           </div>
                                           <div class="product-spec__fertilizer_instructions_text"><b>Step #`+ key +`</b> `+ this.instructionText + `</div>
                                

`
    });
      $('.fertilizerInstructions').html(instructionRow);
    }

      
    }
    
    //Customer Dependant Functions
    if (customer_id>0) {
      if (customerData.isWholesale === true) {
        $(".wholesale").show();
        $(".distributor").hide();
      } else {
        $(".wholesale").hide();
        $(".distributor").hide();
      }
      if (customerData.isDistributor === true) {
        $(".distributor").show();
        $(".wholesale").hide();
      } else {
        $(".distributor").hide();
        $(".wholesale").hide();
      }
    }
    else {
      console.log('no customer');
    }

  var tempId = $('.product').data('section');
  var templateId = (tempId.replace('template--','')).replace('__main','');
  
      $.each(customShopifyData.metaFields[0].variant_metafields, function () {
        const variants = productData.variants;
        const variantId = this.product_variant_id;
        const newProperty = { isWholesale: this.isWholesale };
        const newProperty2 = { isDistributor: this.isDistributor };
        const variant = variants.find((variant) => variant.id === variantId);
        if (variant) {
          Object.assign(variant, newProperty);
          Object.assign(variant, newProperty2);
        }
      });

      var selectedKey = 0;
      var key = -1;
      var availWholesaleVariants = [];
      var availRetailVariants = [];
      var availDistributorVariants = [];

      $.each(productData.variants, function () {
        console.log(this)
        key = key + 1;

        if (this.isWholesale === true) {
          availWholesaleVariants.push({
            variant_id: this.id,
            title: this.title,
            key: key,
          });
        }
        if (this.isDistributor === true) {
          availDistributorVariants.push({
            variant_id: this.id,
            title: this.title,
            key: key,
          });
        }

        if (this.isWholesale === false && this.isDistributor === false) {
          availRetailVariants.push({
            variant_id: this.id,
            title: this.title,
            key: key,
          });
        }
      });
    console.log(availRetailVariants);
     console.log(availWholesaleVariants);
  console.log(availDistributorVariants)
    
  setTimeout(function(){
      //Show Retail Variants
      if (customer_id>0 && customerData.isDistributor === true) {
        console.log('Distributor Customer')
        $.each(availRetailVariants, function () {
          $(
            '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
          ).hide();
        });
        $.each(availWholesaleVariants, function () {
          $(
            '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
          ).hide();
        });
        $.each(availDistributorVariants, function () {
          $(
            '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
          ).show();
        });
        $(
          '#template--'+templateId+'__main-size-opt-' +
            availWholesaleVariants[0].key
        ).click();
      }


    //Show wholesale Variants
      if (customer_id>0 && customerData.isWholesale === true) {
        console.log('Wholesale Customer')
      
        $.each(availRetailVariants, function () {
          $(
            '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
          ).hide();
        });
        $.each(availDistributorVariants, function () {
          $(
            '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
          ).hide();
        });
        $.each(availWholesaleVariants, function () {
          $(
            '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
          ).show();
        });
        $(
          '#template--'+templateId+'__main-size-opt-' +
            availWholesaleVariants[0].key
        ).click();
      }


    //Show Retail Variants
  
      if ((customer_id===0) || (customerData.isWholesale === false && customerData.isDistributor === false)) {
        console.log('Retail Customer');
        $.each(customShopifyData.supressedImages[0].hideRetailImages, function () {
          $(
            '.media-thumbs__item[data-media-id="' + this.media_image_id + '"]'
          ).hide();
          $(
            '.media-viewer__item[data-media-id="' + this.media_image_id + '"]'
          ).hide();
        });
        $(".media-thumbs").css("height", "150px");

        if (customShopifyData.supressedImages[0].supressedCount > 0 && customShopifyData.supressedImages[0].hasOwnProperty('hideRetailImages')) {
          $(".media-ctrl__total-items").html(
            parseFloat($(".media-ctrl__total-items").html()) -
              parseFloat(customShopifyData.supressedImages[0].hideRetailImages.length)
          );
        }
          $.each(availWholesaleVariants, function () {
            console.log(key);
            $(
              '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
            ).hide();
          });
          $.each(availDistributorVariants, function () {
            console.log(key);
            $(
              '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
            ).hide();
          });
          $.each(availRetailVariants, function () {
            $(
              '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
            ).show();
          });
          $(
            '#template--'+templateId+'__main-size-opt-' +
              availRetailVariants[0].key
          ).click();
            $('.product-info').show();
    $(".option-selector__btns").show();
$('.product-info__price').show();
        
      }
     if(customer_id>0 && customerData.isWholesale === true){
            $.each(availWholesaleVariants, function () {
            console.log(key);
            $(
              '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
            ).show();
          });
          $.each(availDistributorVariants, function () {
            console.log(key);
            $(
              '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
            ).hide();
          });
          $.each(availRetailVariants, function () {
            $(
              '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
            ).hide();
          });
       $(
            '#template--'+templateId+'__main-size-opt-' +
              availWholesaleVariants[0].key
          ).click();
           $('.product-info').show();
    $(".option-selector__btns").show();
  $('.product-info__price').show();
     }

     if(customer_id>0 && customerData.isDistributor === true){
            $.each(availWholesaleVariants, function () {
            console.log(key);
            $(
              '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
            ).hide();
          });
          $.each(availDistributorVariants, function () {
            console.log(key);
            $(
              '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
            ).show();
          });
          $.each(availRetailVariants, function () {
            $(
              '[for="template--'+templateId+'__main-size-opt-' + this.key + '"]'
            ).hide();
          });
       $(
            '#template--'+templateId+'__main-size-opt-' +
              availDistributorVariants[0].key
          ).click();
           $('.product-info').show();
    $(".option-selector__btns").show();
  $('.product-info__price').show();
     }

    
  },100);

    

    //Pest Control Data
    if (customShopifyData.hasOwnProperty("pestControlled")) {
      console.log('true')
      var count = customShopifyData.pestControlled.length;
      var columns = Math.ceil(count / 2);
      var key = 0;
      var col1 = "";
      var col2 = "";
      $.each(customShopifyData.pestControlled, function () {
        key = key + 1;
        if (key < columns + 1) {
          col1 +=
            `<span>` + this.icon + ` ` + this.displayName + `</span></br>`;
        }
        if (key > columns && key < columns * 2 + 1) {
          col2 +=
            `<span>` + this.icon + ` ` + this.displayName + `</span></br>`;
        }
      });

      $("#pest_controlled_block1").html(col1);
      $("#pest_controlled_block2").html(col2);
    }
    
    if (customShopifyData.hasOwnProperty("tolerantCrops")) {
      var count = customShopifyData.tolerantCrops.length;
      var columns = Math.ceil(count / 2);
      var key = 0;
      var col1 = "";
      var col2 = "";
      console.log("crop count:", count);
      $.each(customShopifyData.tolerantCrops, function () {
        key = key + 1;
        if (key < columns + 1) {
          col1 +=
            `<span>` + this.icon + ` ` + this.displayName + `</span></br>`;
        }
        if (key > columns && key < columns * 2 + 1) {
          col2 +=
            `<span>` + this.icon + ` ` + this.displayName + `</span></br>`;
        }
      });

      $("#crop_tolerant_block1").html(col1);
      $("#crop_tolerant_block2").html(col2);
    }
 
}

//END BRIAN BUCHANAN
